<template>
	<div ref="tooltip" class="tooltip-container">
		<div class="tooltip is-fixed" :style="{ left: posX, top: posY }">
			<div class="tooltip-content">
				<slot name="tooltip"></slot>
			</div>
		</div>

		<slot />
	</div>
</template>

<script lang="ts">
	import { Options, Vue } from 'vue-class-component';
	import { GeneralHelper } from '../helper/general';

	@Options({
		name: 'Tooltip',
		inject: ['helper'],
		props: ['fixed'],
	})
	export default class Tooltip extends Vue {
		public helper!: GeneralHelper;
		public fixed!: boolean;
		public trigger!: boolean;
		public posX = '0px';
		public posY = '0px';
		public updateDebounce: any;

		public update() {
			const tooltip = this.$refs.tooltip as HTMLElement;
			if (!tooltip) return;

			const rect = tooltip.getBoundingClientRect();

			this.posY = `${Math.floor(rect.top)}px`;
			this.posX = `${Math.floor(rect.left + (tooltip.clientWidth / 2))}px`;
		}

		public mounted(): void {
			this.update();
			this.updateDebounce = this.helper.debounce(this.update, 50);

			const tooltip = this.$refs.tooltip as HTMLElement;
			tooltip?.addEventListener('mouseenter', this.updateDebounce);
		}

		public unmounted(): void {
			const tooltip = this.$refs.tooltip as HTMLElement;
			tooltip?.removeEventListener('mouseenter', this.updateDebounce);
		}
	}
</script>

<style lang="scss" scoped>
	.tooltip-container {
		position: relative;
		display: inline-block;
		width: 100%;
		height: 100%;
		&:hover {
			.tooltip {
				opacity: 1;
				visibility: visible;
				transition: opacity 0.2s ease-in;
			}
		}

		.tooltip {
			opacity: 0;
			visibility: hidden;
			transition: opacity 0.2s ease-out, visibility 0s linear 0.2s;
			position: absolute;
			background: white;
			color: black;
			padding: 8px 12px;
			border-radius: 6px;
			font-size: 13px;
			box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
			border: 1px solid rgba(0, 0, 0, 0.2);
			z-index: 9999;
			width: 300px;
			max-height: 180px;
			left: 50%;
			transform: translateX(-50%) translateY(calc(-100% - 10px));

			&.is-fixed {
				position: fixed;
			}

			&::after {
				content: "";
				position: absolute;
				top: 100%;
				left: 50%;
				transform: translateX(-50%);
				border-width: 6px;
				border-style: solid;
				border-color: white transparent transparent transparent;
				filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
			}

			.tooltip-content {
				display: flex;
				flex-direction: column;
				max-height: 150px;
				overflow-y: auto;
				width: 100%;
				padding: 8px;
				text-wrap: wrap;
			}
		}
	}
</style>
